// extracted by mini-css-extract-plugin
export default {"flex-column":"editProfile_flex-column__I76n7","edit-profile":"editProfile_edit-profile__yys-d","flex-row":"editProfile_flex-row__fH7LH","page-size":"editProfile_page-size__eM1JD"};